function BreadCrumb() {
  return null;
}

export default BreadCrumb;
